import { useSelector } from 'react-redux';
import "./footer.cmp.scss"

function Footer() {
    const footer = useSelector((state) => state.UI.footer);
    return <div dangerouslySetInnerHTML={{__html: footer}} />;
}

export default Footer;